var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arc-el",class:[
    _vm.borderColor,
    { 'arc-el--fade-in': _vm.fadeIn }
  ],style:(("\n    transform: rotate(" + _vm.rotation + "deg);\n    left: " + _vm.positionX + "%;\n    top: " + _vm.positionY + "%;\n  "))})}
var staticRenderFns = []

export { render, staticRenderFns }